import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

const RequiredAuth = ({ user }) => {
    let location = useLocation();
    
    if (!user) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="auth/login" state={{ from: location }} />;
    } else if (user && !user.token.claims.email_verified) {
        return <Navigate to="auth/not-verified" state={{ from: location }} />;
    } else if (user && !user.private) {
        return <Navigate to="auth/new-user" state={{ from: location }} />;
    }

    return <Outlet />;
};

export default RequiredAuth;